import { render, staticRenderFns } from "./info_company.vue?vue&type=template&id=da5894be&scoped=true&"
import script from "./info_company.vue?vue&type=script&lang=js&"
export * from "./info_company.vue?vue&type=script&lang=js&"
import style0 from "./info_company.vue?vue&type=style&index=0&id=da5894be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5894be",
  null
  
)

export default component.exports